<template>
  <el-select
    :value="value"
    @input="updateValue"
    :placeholder="placeholder"
    clearable
    style="width: 100%"
  >
    <el-option label="全国" value="100000"> </el-option>
    <el-option
      v-for="item in REGIONDATA"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
import { regionData } from "element-china-area-data";
export default {
  name: "province", //地区
  props: {
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: "地区"
    }
  },
  data() {
    return {
      REGIONDATA: regionData
    };
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="less" scoped></style>
